export const THEME_STORAGE_KEY = 'sim-theme';
export const DEFAULT_THEME = 'dark';

const isValidTheme = (theme) => theme === 'light' || theme === 'dark';

export const getStoredTheme = () => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    return isValidTheme(saved) ? saved : null;
  } catch {
    return null;
  }
};

export const applyTheme = (theme) => {
  if (!isValidTheme(theme)) {
    return;
  }
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Storage unavailable (private mode, quota, etc.) — DOM theme still applies
  }
};

export const toggleTheme = () => {
  const current = document.documentElement.dataset.theme || DEFAULT_THEME;
  const next = current === 'dark' ? 'light' : 'dark';
  applyTheme(next);
  return next;
};

export const initTheme = () => {
  const saved = getStoredTheme();
  document.documentElement.dataset.theme = saved || DEFAULT_THEME;
};
